import React from 'react';
import { compose } from 'recompose';
import { hot } from 'react-hot-loader';
import { Link } from 'react-router-dom';
import { Form,Icon } from 'semantic-ui-react';
import Remarks from 'op/components/remarks';

import { withLocale } from 'op/components/locale';
import { withReportSelection } from './report-view.helper';

import ReportMeta from 'op/components/report/meta';
import ReportFeeback from 'op/components/report/feedback';
import ReportEvaluation from 'op/components/report/evaluation';
import ReportSignatures from 'op/components/report/signature';
import {useHistory} from "react-router";

const ReportPage = ({locale, report }) => {
	const history = useHistory();
return(
	<Form>
		<button onClick={history.goBack}><Icon name='arrow left'/></button>
		<ReportMeta readOnly={['timestamp', 'location', 'type', 'category']} report={report} />
		<ReportEvaluation report={report} readOnly />
    <ReportFeeback report={report} readOnly />
		<ReportSignatures report={report} readOnly />
		{ report.reportedBy && <div>{locale.reportedBy} : { report.reportedBy }</div> }
	</Form>
)};

export default compose(
	withLocale('report.person'),
  	hot(module),
	withReportSelection
)(ReportPage);